import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { siteConfig } from '../data/siteConfig';
const EASE = [0.23, 1, 0.32, 1] as const;
const TICKS = Array.from({
  length: 72
}, (_, i) => i);
export function HeroLogoMark() {
  const reduce = useReducedMotion();
  return <div className="relative mx-auto aspect-square w-full max-w-[460px]" aria-hidden="true" data-id="element-52" data-mp="3hngnm89n8y9o">
      <svg viewBox="0 0 400 400" className="absolute inset-0 h-full w-full" data-id="element-53" data-mp="6grrnoegi0y">
        <motion.g style={{
        originX: '200px',
        originY: '200px'
      }} initial={reduce ? false : {
        opacity: 0
      }} animate={{
        opacity: 1,
        rotate: reduce ? 0 : 360
      }} transition={{
        opacity: {
          duration: 0.3,
          ease: EASE
        },
        rotate: {
          duration: 120,
          ease: 'linear',
          repeat: Infinity
        }
      }} data-id="element-54" data-mp="8jpyuzphhgr">
          <circle cx="200" cy="200" r="192" fill="none" stroke="#D9C29A" strokeOpacity="0.35" strokeWidth="1" strokeDasharray="2 7" data-id="element-55" data-mp="2azjm5d0oves5" />
        </motion.g>

        <motion.g style={{
        originX: '200px',
        originY: '200px'
      }} initial={reduce ? false : {
        opacity: 0
      }} animate={{
        opacity: 1,
        rotate: reduce ? 0 : -360
      }} transition={{
        opacity: {
          duration: 0.3,
          ease: EASE,
          delay: 0.06
        },
        rotate: {
          duration: 180,
          ease: 'linear',
          repeat: Infinity
        }
      }} data-id="element-56" data-mp="1xcw0cpq5yjsz">
          {TICKS.map(i => <line key={i} x1="200" y1={i % 6 === 0 ? 30 : 34} x2="200" y2="40" stroke="#C9AA78" strokeOpacity={i % 6 === 0 ? 0.7 : 0.3} strokeWidth="1" transform={`rotate(${i * 5} 200 200)`} data-id="element-57" data-mp="2g3m40gnk6amw" />)}
        </motion.g>

        <motion.circle cx="200" cy="200" r="140" fill="none" stroke="#F3EADB" strokeOpacity="0.12" strokeWidth="1" initial={reduce ? false : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.12
      }} data-id="element-58" data-mp="2uyk09kltvk99" />
      </svg>

      <motion.div className="absolute inset-0 flex items-center justify-center" initial={reduce ? false : {
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      ease: EASE,
      delay: 0.1
    }} data-id="element-59" data-mp="nnw3mrm2zd47">
        <motion.img src={siteConfig.logoUrl} alt="" className="w-[68%] mix-blend-screen" animate={reduce ? undefined : {
        y: [0, -6, 0]
      }} transition={{
        duration: 7,
        ease: 'easeInOut',
        repeat: Infinity
      }} data-id="element-60" data-mp="1bkrxybjrhur3" />
      </motion.div>
    </div>;
}